import React from 'react';
import classnames from 'classnames';
import Button from '../Button';
import styles from './Header.module.scss';
import logo from '../../images/logo.svg';
import logoMobile from '../../images/logo-main.svg';
import menuIcon from '../../images/menu-icon.svg';
import menuCloseIcon from '../../images/menu-close.svg';
import useScreenSize from '../../hooks/useScreenSize';

function Header() {
  const { isTablet } = useScreenSize();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const renderMenuItems = () => (
    <>
      <li>
        <a href="/oficinas">Oficinas</a>
      </li>
      <li>
        <a href="/almanaque">Almanaque</a>
      </li>
      <li>
        <a href="/sebrae">Sebrae</a>
      </li>
      <li>
        <a href="/prefeituras">Prefeituras</a>
      </li>
      <li>
        <a href="/parceiros">Parceiros e depoimentos</a>
      </li>
      <li>
        <a href="/colegios">Colégios</a>
      </li>
      <li>
        <a href="/quem-somos">Quem somos</a>
      </li>
    </>
  );

  const renderAside = () => (
    <aside className={styles.aside}>
      <Button variant="primary">PARA PAIS</Button>
      <Button variant="outlined">PARA ESCOLAS</Button>
    </aside>
  );

  if (isTablet) {
    return (
      <header className={classnames(styles.header, styles.headerMobile)}>
        <div className={styles.content}>
          <a href="/">
            <img className={styles.logo} src={logoMobile} alt="logo" />
          </a>
          <button onClick={toggleMenu} type="button">
            <img
              className={classnames(styles.menuIcon, {
                [styles.isOpen]: isMenuOpen,
              })}
              src={isMenuOpen ? menuCloseIcon : menuIcon}
              alt="menu"
            />
          </button>
        </div>

        {isMenuOpen && (
          <>
            <ul className={styles.menu}>{renderMenuItems()}</ul>
            {renderAside()}
          </>
        )}
      </header>
    );
  }

  return (
    <header className={classnames(styles.header, styles.headerDesktop)}>
      <a href="/">
        <img className={styles.logo} src={logo} alt="logo" />
      </a>
      <ul className={styles.menu}>{renderMenuItems()}</ul>
      {renderAside()}
    </header>
  );
}

export default Header;
